// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3fdb048","453":"c1444e14","455":"9ccf48c0"}[chunkId] + ".chunk.js";
};